// extracted by mini-css-extract-plugin
export default {"introCopy":"b2iJF8CisVA6N9gDfomD","headline":"fxn5M2_M5e_UiE_0WAPf"};